import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";
import SolicitudCredito from "../interfaces/SolicitudCredito.interface";
import Usuario from "../interfaces/Usuario.interface";
import UsuarioModel from "../models/Usuario.model";

const url = `${ApiConfig.URLBase}/sc`

const guardar = async (solicitudCredito: SolicitudCredito): Promise<Response> => {

    const usuario: Usuario = await UsuarioModel.cookie();

    solicitudCredito = { ...solicitudCredito, usuario: { IdUsuario: usuario.IdUsuario, nombre: "" } }

    console.log({ solicitudCredito })

    const request: Request = {
        url: `${url}/guardar`,
        metodo: "POST",
        data: { solicitudCredito }
    };
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const listar = async (IdCliente: number): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar/${IdCliente}`,
        metodo: "GET",
    };
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const eliminar = async (IdSolicitud: number): Promise<Response> => {

    const request: Request = {
        url: `${url}/eliminar/${IdSolicitud}`,
        metodo: "DELETE",
    };
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const listarCatalogo = async (): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar-catalogo`,
        metodo: "GET",
    };
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const SolicitudCreditoService = {
    listarCatalogo,
    listar,
    eliminar,
    guardar
};

export default SolicitudCreditoService;